'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarEmpty;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CalendarEmpty(_ref) {
  var onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      polyglot = _ref.polyglot,
      errors = _ref.errors;

  return _react2.default.createElement(
    'div',
    {
      id: 'event-dates-box',
      className: 'dashed-box event-dates-box' + (errors.length > 0 ? ' has-error' : ''),
      onClick: onClick,
      onFocus: onFocus
    },
    _react2.default.createElement('span', { className: 'icon-cg-calendar' }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { className: 'dashed-box-bottom-text' },
      _react2.default.createElement(
        'label',
        null,
        polyglot.t('events.form.calendar.dateTime')
      ),
      _react2.default.createElement(
        'span',
        { className: 'label label-danger label-required' },
        polyglot.t('events.form.required')
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/DatesBox/CalendarEmpty.js
// module id = 2206
// module chunks = 0